"use client";

import { ImageIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from "./ui/select";
import { useEffect } from "react";

const __ = (key: string) => key;

declare global {
    interface Window {
        cliparts: any;
        loadThumbs: (category: string, size: number) => void;
    }
}

const ClipartsScreen = () => {

    useEffect(() => {
        // garante que o script legado já carregou
        if (!window.cliparts) {
            console.warn("cliparts legacy script não carregado ainda");
        }
    }, []);

    const handleCategoryChange = (category: string) => {

        if (!window.cliparts || !window.loadThumbs) return;

        const clipart = window.cliparts[category];
        if (!clipart) return;

        // carrega thumbs sob demanda
        if (!clipart.loaded && category !== "Custom") {
            window.loadThumbs(category, clipart.size);
            clipart.loaded = true;
        } else if(category === "Custom") {
            (window as any)["loadCliparts"](false);
        }

        // esconde todos
        (window as any).$?.("#patterns div").hide();

        // mostra apenas a categoria selecionada
        (window as any).$?.("." + category).show();
    };

    const clipartCategories = [
        "simulador",
        "Custom",
        "Backgrounds",
        "Animais",
        "Baseball",
        "Basketball",
        "Beer",
        "Cannabis",
        "carros",
        "ciclismo",
        "Downhill",
        "et",
        "Formandos",
        "hacker",
        "mascots",
        "MOTOCROSS",
        "Motorcycle",
        "Patterns",
        "Pescaria",
        "Rafting",
        "scudos",
        "Skate",
        "Surf"
    ];

    return (
        <Card className="w-full border-none shadow-lg bg-card/85 backdrop-blur-sm h-full rounded-none">
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-foreground/80">
                    <ImageIcon className="h-4 w-4" />
                    <span>{__("CLIPARTS")}</span>
                </CardTitle>
            </CardHeader>

            <CardContent className="space-y-4">
                <Select
                    defaultValue="simulador"
                    onValueChange={handleCategoryChange}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Selecione uma categoria" />
                    </SelectTrigger>

                    <SelectContent>
                        {clipartCategories.map((category) => (
                            <SelectItem key={category} value={category}>
                                {category}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>

                <div
                    id="patterns"
                    className="min-h-[80px] rounded-lg border border-dashed border-muted-foreground/25 bg-muted/30 p-3 overflow-y-auto"
                />

                <div
                    id="patternsRegistrados"
                    className="registradosClipArts min-h-[60px] rounded-lg border border-dashed border-muted-foreground/25 bg-muted/30 p-3"
                />
            </CardContent>
        </Card>
    );
};

export default ClipartsScreen;
